import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

import type { MembershipGroupCard } from 'src/features/memberships/types';
import type { GeneralSmartParkMixedError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/cards/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    number: z.string().min(1, { message: validationMessagesMap.validationErrorRequired }).max(13),
    tags: z.array(z.string()),
    description: z.string().optional(),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
    membershipGroupId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, ...data }: DTO): Promise<MembershipGroupCard> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkMixedError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as CREATE_MEMBERSHIP_GROUP_CARD_RESOURCE,
    useMutationHook as useCreateMembershipGroupCard,
    formSchema as createMembershipGroupCardFormSchema,
};
export type { DTO as CreateMembershipGroupCardDTO, FormSchemaValues as CreateMembershipGroupCardFormSchemaValues };
